import {
  AiDetectedSubmissionReport,
  SubmissionPlagiarismReport,
} from "api/resources/submissions/types"
import { useSkillEvidenceStyles } from "utils/hooks/useSkillEvidenceStyles"

import AiDetectedSubmission from "./AiDetectedSubmission"
import PlagiarisedSubmissionView from "./PlagiarisedSubmission"

export type SubmissionViewMode = "plagiarism" | "ai" | "default"

const SubmissionContent = ({
  viewMode,
  submissionId,
  submission,
  plagiarismData,
  aiDetectedReportData,
  showSources,
}: {
  viewMode?: SubmissionViewMode
  submissionId: string
  submission: string | null
  plagiarismData?: SubmissionPlagiarismReport
  aiDetectedReportData?: AiDetectedSubmissionReport
  showSources?: boolean
}) => {
  const styles = useSkillEvidenceStyles()
  if (viewMode === "plagiarism" && plagiarismData) {
    return (
      <PlagiarisedSubmissionView
        data={plagiarismData}
        submissionId={submissionId}
        showSources={showSources}
      />
    )
  }

  if (viewMode === "ai") {
    return (
      <AiDetectedSubmission
        aiDetectedReportData={aiDetectedReportData}
        submissionId={submissionId}
      />
    )
  }
  return (
    <div
      id="submission-text"
      className={styles.className}
      dangerouslySetInnerHTML={{
        __html: submission || "",
      }}
    />
  )
}

export default SubmissionContent
